export const DATE_STRING_LENGTH = 2;
export const DATE_YEAR_STRING_LENGTH = 4;
export const DOB_MIN_AGE = 18;
export const DEFAULT_DATE_INPUT_FORMAT = "dd/MM/yyyy";
